export class DeviceInfoModel
{
    Username:string;
    DeviceId:string;
    DeviceToken:string;
}